import React, { useState } from "react";
import "./form5.css";
import { useNavigate } from 'react-router-dom';

const Formta5 = ({ formData, setFormData, setStep }) => {


  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      setFormData({ ...formData, [name]: files[0] });
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.profilePhoto1) newErrors.profilePhoto1 = "required";
    if (!formData.horoscopePhoto) newErrors.horoscopePhoto = "required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (validate()) {
      setStep(6);
    }
  };

  const handleBack = () => {
    setStep(4);
  };

  return (
    <div className="form5-background">
      <div className="form5-section">
        <h2 className="form5-title">புகைப்படங்களை பதிவேற்றுக(5/7)</h2>
        <form>
          <div className="form5-row">

            {/* Profile Photo 1 */}
            <div className="form5-group">
              <label>சுயவிவர புகைப்படம் 1<span className='error fs-star'>*</span></label>
              <input type="file" name="profilePhoto1" onChange={handleChange} />
              {formData.profilePhoto1 && (
                <div className="preview">
                  <img
                    src={URL.createObjectURL(formData.profilePhoto1)}
                    alt="Preview"
                    width={100}
                  />
                </div>
              )}
              {errors.profilePhoto1 && <span className="error-text">{errors.profilePhoto1}</span>}
            </div>

            {/* Profile Photo 2 */}
            <div className="form5-group margin-align">
              <label>சுயவிவர புகைப்படம் 2</label>
              <input type="file" name="profilePhoto2" onChange={handleChange} />
              {formData.profilePhoto2 && (
                <div className="preview">
                  <img
                    src={URL.createObjectURL(formData.profilePhoto2)}
                    alt="Preview"
                    width={100}
                  />
                </div>
              )}
            </div>

            {/* Horoscope Photo */}
            <div className="form5-group">
              <label>ஜாதகப் புகைப்படம்<span className='error fs-star'>*</span></label>
              <input type="file" name="horoscopePhoto" onChange={handleChange} />
              {formData.horoscopePhoto && (
                <div className="preview">
                  <img
                    src={URL.createObjectURL(formData.horoscopePhoto)}
                    alt="Preview"
                    width={100}
                  />
                </div>
              )}
              {errors.horoscopePhoto && <span className="error-text">{errors.horoscopePhoto}</span>}
            </div>

          </div>

          <div className="form5-btn-group">
            <button type="button" className="back-btn-5" onClick={handleBack}>Back</button>
            <button type="button" onClick={handleNext} className="submit-btn-5">Continue</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Formta5;
